import React from 'react';
import Select from 'react-select';

const customStyles = {
  option: (provided, state) => ({
    ...provided,
      color: state.isSelected ? '#FFFFFF' : 'black',
      textAlign:'left',
    }),
  control: (provided, state) => ({
    ...provided,
    backgroundColor:'#FFFFFF',
    color: '#000000',
    display:'flex',
    border: state.isFocused ? '2px solid #007bff' : '1px solid #ddd',
        boxShadow: state.isFocused ? '0 0 5px rgba(0, 123, 255, 0.5)' : 'none',
        '&:hover': {
            border: '1px solid #ccc',
        },
  }),
  singleValue:(provided)=>({
    ...provided,
    color: '#000000'
  }),
  placeholder:(provided)=>({
    ...provided,
    fontSize:'16px'
  }),
  container:(provided)=>({
    ...provided,
    // marginLeft:'-12px',
    padding:'0px',
    border:'0px',
    
  }),
  hasFocus:(provided)=>({
    ...provided,
    // marginLeft:'-12px',
    border:'10px'
  }),
  
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
    position: 'absolute',
    backgroundColor: '#fff',
    boxShadow: '0px 4px 10px rgba(0,0,0,0.1)',
  }),

  menuPortal: base => ({
    ...base,
    zIndex: 9999
  }),

  menuList: (provided) => ({
    ...provided,
    maxHeight: '150px',
    overflowY: 'auto',
  }),
  
}


class SelectSearch extends React.Component {
  

  render(){
    
      return ( 
        
                <Select 
                    options={this.props.options}  
                    className={this.props.className} 
                    onChange={this.props.onChange} 
                    placeholder={this.props.placeholder}
                    value={this.props.value}
                    styles = { customStyles }
                    onKeyDown ={this.props.onType}
                    menuPortalTarget={document.body}          // 👈 ensures dropdown renders outside parents
                    menuPosition="fixed"  
                />
          
      );
    
 
  }
}

export default SelectSearch;
